import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Container, // aggiunto qui
  Collapse,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Person,
  School,
  AdminPanelSettings,
  ExitToApp,
  // Home,
  Book,
  // CardMembership,
  // Dashboard,
  Login,
  PersonAdd,
  DeveloperMode,
  Help,
  Event,
  PlayArrow, // Aggiungo questa icona per le lezioni di prova
  Wallpaper, // Icona per le Vie (walls)
  CalendarToday, // Icona per le Prenotazioni
  ListAlt, // Icona per Le Mie Prenotazioni
  ArrowDropDown, // Icona per dropdown
  ExpandLess,
  ExpandMore,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import FloatingAdmin from './FloatingAdmin';
import getAppConfig from '../config/app-config';

const Navbar = () => {
  const config = getAppConfig();
  // const associate = process.env.REACT_APP_ASSOCIATE;

  // Verifica che le configurazioni necessarie siano presenti
  if (!config.BRAND_NAME) {
    throw new Error('BRAND_NAME non è definita nella configurazione.');
  }

  if (!config.LOGO_URL) {
    throw new Error('LOGO_URL non è definita nella configurazione.');
  }

  const { user, logout, isAuthenticated, isProd } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [adminMenuAnchorEl, setAdminMenuAnchorEl] = useState(null);
  const [reservationsMenuAnchorEl, setReservationsMenuAnchorEl] = useState(null);
  const [coursesMenuAnchorEl, setCoursesMenuAnchorEl] = useState(null);
  const [expandedMobileDropdowns, setExpandedMobileDropdowns] = useState({});

  // Pagine dove non mostrare i pulsanti Login/Register
  const hideAuthButtons = ['/login', '/register', '/verify-email', '/registration-success', '/reset-password', '/forgot-password', '/membership-checkout', '/membership-callback'];
  const shouldHideAuthButtons = hideAuthButtons.includes(location.pathname);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const name = config.BRAND_NAME;
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAdminMenuOpen = (event) => {
    setAdminMenuAnchorEl(event.currentTarget);
  };

  const handleAdminMenuClose = () => {
    setAdminMenuAnchorEl(null);
  };

  const handleReservationsMenuOpen = (event) => {
    setReservationsMenuAnchorEl(event.currentTarget);
  };

  const handleReservationsMenuClose = () => {
    setReservationsMenuAnchorEl(null);
  };

  const handleCoursesMenuOpen = (event) => {
    setCoursesMenuAnchorEl(event.currentTarget);
  };

  const handleCoursesMenuClose = () => {
    setCoursesMenuAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
    handleMenuClose();
  };

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const handleMobileDropdownToggle = (itemText) => {
    setExpandedMobileDropdowns(prev => ({
      ...prev,
      [itemText]: !prev[itemText]
    }));
  };

  const getNavItems = () => {
    const items = [
      // { text: 'Home', path: '/', icon: <Home /> },
    ];

    // Solo se l'utente è autenticato, mostra i link protetti
    if (isAuthenticated) {
      // Per tutti i ruoli
      // items.push(
      //   { text: 'Corsi', path: '/courses', icon: <Book /> },
      //   { text: 'Le Mie Iscrizioni', path: '/my-courses', icon: <School /> },
      // );

      if (user?.roles.includes('member')) {
        items.push(
          { text: 'Calendario', path: '/member-calendar', icon: <Event /> },
          {
            text: 'Corsi',
            icon: <Book />,
            hasDropdown: true,
            dropdownItems: [
              { text: 'Lezioni di Prova', path: '/trial-lessons', icon: <PlayArrow /> },
              { text: 'Elenco Corsi', path: '/courses', icon: <Book /> },
              { text: 'Miei Corsi', path: '/my-courses', icon: <School /> }
            ]
          }
          // { text: 'Membri', path: '/memberships', icon: <CardMembership /> }
        );
      }

      if (user?.roles.includes('teacher')) {
        items.push({ text: 'Area Docente', path: '/teacher', icon: <School /> });
      }

      if (user?.roles.includes('admin')) {
        items.push({ text: 'Amministrazione', path: '/admin', icon: <AdminPanelSettings /> });
      }

      

    }

    if (config.WITH_WALLS) {
      items.push({ text: 'Vie', path: '/walls', icon: <Wallpaper /> });
    }

    if (config.WITH_RESERVATION && isAuthenticated) {
      let dropdownItems = [];
      
      if (user?.roles.includes('member')) {
        dropdownItems = [
          { text: 'Prenota', path: '/reservables', icon: <CalendarToday /> },
          { text: 'Le Mie Prenotazioni', path: '/my-reservations', icon: <ListAlt /> }
        ];
      } else if (user?.roles.includes('admin')) {
        dropdownItems = [
          { text: 'Gestisci', path: '/manage-reservations', icon: <AdminPanelSettings /> }
        ];
      }
      
      if (dropdownItems.length > 0) {
        items.push({
          text: 'Prenotazioni',
          icon: <CalendarToday />,
          hasDropdown: true,
          dropdownItems
        });
      }
    }
    return items;
  };

  const navItems = getNavItems();

  const mobileDrawer = (
    <Box sx={{ width: 250 }}>
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Box
          sx={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
          onClick={() => handleNavigation('/')}
        >
          <img
            src={config.LOGO_URL}
            alt='Logo'
            style={{
              height: '24px',
              width: 'auto',
            }}
          />
          <Typography variant='h6' color='primary'>
            {name}
          </Typography>
        </Box>
        {isAuthenticated && (
          <Typography variant='body2' color='text.secondary'>
            {user?.name} {user?.surname}
          </Typography>
        )}
      </Box>
      <List>
        {navItems.map((item) => (
          item.hasDropdown ? (
            <React.Fragment key={item.text}>
              <ListItemButton 
                onClick={() => handleMobileDropdownToggle(item.text)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
                {expandedMobileDropdowns[item.text] ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={expandedMobileDropdowns[item.text]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.dropdownItems.map((dropdownItem) => (
                    <ListItemButton 
                      key={dropdownItem.text} 
                      sx={{ pl: 4 }}
                      onClick={() => handleNavigation(dropdownItem.path)}
                    >
                      <ListItemIcon>{dropdownItem.icon}</ListItemIcon>
                      <ListItemText primary={dropdownItem.text} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ) : (
            <ListItemButton key={item.text} onClick={() => handleNavigation(item.path)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          )
        ))}

        {!isProd && (
          <>
            <Divider />
            <ListItemButton onClick={() => handleNavigation('/tutorial')}>
              <ListItemIcon>
                <Help />
              </ListItemIcon>
              <ListItemText primary='Tutorial' />
            </ListItemButton>
          </>
        )}

        {isAuthenticated ? (
          <>
            <Divider />
            <ListItemButton onClick={() => handleNavigation('/profile')}>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary='Profilo' />
            </ListItemButton>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText primary='Logout' />
            </ListItemButton>
          </>
        ) : !shouldHideAuthButtons ? (
          <>
            <Divider />
            <ListItemButton onClick={() => handleNavigation('/login')}>
              <ListItemIcon>
                <Login />
              </ListItemIcon>
              <ListItemText primary='Login' />
            </ListItemButton>
            <ListItemButton onClick={() => handleNavigation('/register')}>
              <ListItemIcon>
                <PersonAdd />
              </ListItemIcon>
              <ListItemText primary='Registrati' />
            </ListItemButton>
          </>
        ) : null}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position='sticky' sx={{ borderRadius: 0 }}>
        <Toolbar disableGutters>
          <Container maxWidth='lg' sx={{ px: { xs: 2, sm: 3 } }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: { xs: 'space-between', md: 'flex-start' },
              }}
            >
              {isMobile && (
                <IconButton color='inherit' edge='start' onClick={handleMobileToggle} sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
              )}

              {/* Mostra il logo solo su desktop */}
              {!isMobile && (
                <Box
                  sx={{
                    flexGrow: 1,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      opacity: 0.8,
                    },
                  }}
                  onClick={() => navigate('/')}
                >
                  <img
                    src={config.LOGO_URL}
                    alt='Logo'
                    style={{
                      height: '40px',
                      width: 'auto',
                    }}
                  />
                  <Typography
                    variant='h5'
                    component='div'
                    sx={{
                      fontWeight: 'bold',
                    }}
                  >
                    {name}
                  </Typography>
                </Box>
              )}

              {!isMobile && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {/* Tutorial Button - Left of role-specific menu */}
                  {!isProd && (
                    <Button
                      color='inherit'
                      onClick={() => navigate('/tutorial')}
                      startIcon={<Help />}
                      // variant='outlined'
                      sx={{
                        borderColor: 'white',
                        color: 'white',
                        '&:hover': {
                          borderColor: 'white',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                      }}
                    >
                      Tutorial
                    </Button>
                  )}

                  {navItems.map((item) => (
                    item.hasDropdown ? (
                      <Button
                        key={item.text}
                        color='inherit'
                        onClick={item.text === 'Prenotazioni' ? handleReservationsMenuOpen : handleCoursesMenuOpen}
                        startIcon={item.icon}
                        endIcon={<ArrowDropDown />}
                      >
                        {item.text}
                      </Button>
                    ) : (
                      <Button key={item.text} color='inherit' onClick={() => handleNavigation(item.path)} startIcon={item.icon}>
                        {item.text}
                      </Button>
                    )
                  ))}
                </Box>
              )}

              <Box sx={{ display: 'flex', alignItems: 'center', ml: { xs: 0, md: 2 } }}>
                {!isProd ? (
                  <IconButton color='inherit' onClick={handleAdminMenuOpen} sx={{ mr: 1 }} title='Admin Tools'>
                    <DeveloperMode />
                  </IconButton>
                ) : null}
                {isAuthenticated ? (
                  <IconButton onClick={handleMenuOpen} sx={{ color: 'inherit' }}>
                    <Avatar sx={{ width: 48, height: 48, bgcolor: 'secondary.main', borderColor: 'white', border: 2 }} src={user?.avatar ? (user.avatar.startsWith('data:image/') ? user.avatar : `/avatars/${user.avatar}`) : undefined}>
                      {(!user?.avatar || user.avatar === '') && (user?.name?.charAt(0)?.toUpperCase() || 'U')}
                    </Avatar>
                  </IconButton>
                ) : !shouldHideAuthButtons && !isMobile ? (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button color='inherit' onClick={() => navigate('/login')} startIcon={<Login />}>
                      Login
                    </Button>
                    <Button
                      color='inherit'
                      onClick={() => navigate('/register')}
                      startIcon={<PersonAdd />}
                      variant='outlined'
                      sx={{
                        borderColor: 'white',
                        color: 'white',
                        '&:hover': {
                          borderColor: 'white',
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                      }}
                    >
                      Registrati
                    </Button>
                  </Box>
                ) : !shouldHideAuthButtons && isMobile && !isProd ? (
                  <Button
                    color='inherit'
                    onClick={() => navigate('/tutorial')}
                    startIcon={<Help />}
                    variant='outlined'
                    sx={{
                      borderColor: 'white',
                      color: 'white',
                      '&:hover': {
                        borderColor: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      },
                    }}
                  >
                    Tutorial
                  </Button>
                ) : null}
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>

      {/* Desktop Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => {
            handleNavigation('/profile');
            handleMenuClose();
          }}
        >
          <Person sx={{ mr: 1 }} />
          Profilo
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ExitToApp sx={{ mr: 1 }} />
          Logout
        </MenuItem>
      </Menu>

      {/* Admin Tools Menu */}
      <Menu
        anchorEl={adminMenuAnchorEl}
        open={Boolean(adminMenuAnchorEl)}
        onClose={handleAdminMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            width: 280,
            maxHeight: 400,
            overflow: 'auto',
          },
        }}
      >
        <FloatingAdmin />
      </Menu>

      {/* Reservations Dropdown Menu */}
      <Menu
        anchorEl={reservationsMenuAnchorEl}
        open={Boolean(reservationsMenuAnchorEl)}
        onClose={handleReservationsMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {navItems
          .filter(item => item.hasDropdown && item.text === 'Prenotazioni')
          .flatMap(item => item.dropdownItems)
          .map((dropdownItem) => (
            <MenuItem
              key={dropdownItem.text}
              onClick={() => {
                handleNavigation(dropdownItem.path);
                handleReservationsMenuClose();
              }}
            >
              <ListItemIcon>{dropdownItem.icon}</ListItemIcon>
              <ListItemText primary={dropdownItem.text} />
            </MenuItem>
          ))}
      </Menu>

      {/* Courses Dropdown Menu */}
      <Menu
        anchorEl={coursesMenuAnchorEl}
        open={Boolean(coursesMenuAnchorEl)}
        onClose={handleCoursesMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {navItems
          .filter(item => item.hasDropdown && item.text === 'Corsi')
          .flatMap(item => item.dropdownItems)
          .map((dropdownItem) => (
            <MenuItem
              key={dropdownItem.text}
              onClick={() => {
                handleNavigation(dropdownItem.path);
                handleCoursesMenuClose();
              }}
            >
              <ListItemIcon>{dropdownItem.icon}</ListItemIcon>
              <ListItemText primary={dropdownItem.text} />
            </MenuItem>
          ))}
      </Menu>

      {/* Mobile Drawer */}
      <Drawer
        variant='temporary'
        anchor='left'
        open={mobileOpen}
        onClose={handleMobileToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 250 },
        }}
      >
        {mobileDrawer}
      </Drawer>
    </>
  );
};

export default Navbar;
